<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
    <mat-expansion-panel-header class="disable_ripple">
        <mat-panel-title>
            <!-- <b [ngStyle]="{color: this.frmOsy.errors?.['required'] ? 'red': ''}" class="disable_ripple_font">OUT-OF-SCHOOL YOUTH (CURRENTLY ENROLLED IN GRADES NA, AD) </b> -->

            <div *ngIf="this.frmOsy.errors?.['required']==null">
                <b>OUT-OF-SCHOOL YOUTH (CURRENTLY ENROLLED IN GRADES NA, AD) </b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_Overview'"></help-text-btn>
            </div>
            <div *ngIf="this.frmOsy.errors?.['required']">
                <b style="color: red;">OUT-OF-SCHOOL YOUTH (CURRENTLY ENROLLED IN GRADES NA, AD) (incomplete)</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_Overview'"></help-text-btn>
            </div>
        </mat-panel-title>

    </mat-expansion-panel-header>

    <form [formGroup]="frmOsy">
        <!-- Current Parent/Guardian 1  Relationship  Phone 1-->
        <div class="row">
            <div class="col-3">
                <mat-label><b>Married/Partner? </b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_MarriedPartner'"></help-text-btn>
                </mat-label>               
                <mat-radio-group aria-label name="radioMarriedPartner" formControlName="radioMarriedPartner"
                    id="radioMarriedPartner">
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="1">Yes</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="2">No</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
            <div class="col-3">
                <mat-label><b>Children?</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_Children'"></help-text-btn>
                </mat-label>                
                <mat-radio-group aria-label name="radioChildren" formControlName="radioChildren" id="radioChildren">
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="1">Yes</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="2">No</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
            <div class="col-3">
                <mat-label><b>Last grade attended</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_LastGradeAttended'"></help-text-btn>
                </mat-label>
                <div class="col">
                    <mat-form-field  appearance="fill">
                        <mat-select formControlName="gradeAttended">
                            <mat-option *ngFor="let gradeAttended of lstlastGradeAttendeds"
                                [value]="gradeAttended.name">
                                {{ gradeAttended.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-3">
                <p style="line-height:3px;">&nbsp;</p>
                <mat-label><b>Where?</b> &NonBreakingSpace;</mat-label>
                <p style="line-height:0px;">&nbsp;</p>
                <div class="col">
                    <mat-form-field >
                        <input matInput type="string" placeholder="Entere where?" formControlName="where"
                            (focusout)="updateChangeValueLostFocus()" />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="row" style="padding-top: 10px">
            <span><b>English Proficiency</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_EnglishProficiency'"></help-text-btn>
			</span>
        </div>
        <div class="row" style="padding-top: 10px">
            <div class="col-3">
                <mat-label><b>Speaking </b>&NonBreakingSpace;</mat-label>
                <mat-radio-group aria-label name="radioSpeaking" formControlName="radioSpeaking" id="radioSpeaking">
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="1">High</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="2">Medium</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="3">Low</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="4">None</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
            <div class="col-3">
                <mat-label><b>Reading </b>&NonBreakingSpace;</mat-label>
                <mat-radio-group aria-label name="radioReading" formControlName="radioReading" id="radioReading">
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="1">High</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="2">Medium</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="3">Low</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="4">None</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
            <div class="col-3">
                <mat-label><b>Writing </b>&NonBreakingSpace;</mat-label>
                <mat-radio-group aria-label name="radioWriting" formControlName="radioWriting" id="radioWriting">
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="1">High</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="2">Medium</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="3">Low</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="4">None</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
            <div class="col-3">
                <div style="position:absolute;margin-top:-15px;">
                    <mat-label><b>Preferred Language</b>
						<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_PreferredLanguage'"></help-text-btn>
                    </mat-label>
                    <mat-radio-group aria-label name="radioPreferred" formControlName="radioPreferred" id="radioPreferred">
                        <div class="col">
                            <mat-radio-button [color]="'primary'" class="example-radio-button"
                                value="1">Spanish</mat-radio-button>
                        </div>
                        <div class="col">
                            <mat-radio-button [color]="'primary'" class="example-radio-button"
                                value="2">English</mat-radio-button>
                        </div>
                        <div class="col">
                            <mat-radio-button [color]="'primary'" class="example-radio-button"
                                value="3">Other</mat-radio-button>
                        </div>
                    </mat-radio-group>
                    <mat-form-field appearance="outline" class="example-radio-button">
                        <mat-label>Other</mat-label>
                        <input matInput placeholder="Other Language" formControlName="preferredOther"
                            (focusout)="updateChangeValueLostFocus()" />
                    </mat-form-field>
                </div>    
            </div>
            <p>&nbsp;</p>            
            <p>&nbsp;</p>            
        </div>

        <mat-divider></mat-divider>
        <div class="row" style="padding-top: 10px">
            <div class="col-6">
                <mat-label><b>Youth is </b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_YouthIs'"></help-text-btn>
                </mat-label>
                <mat-radio-group aria-label name="radioYouth" formControlName="radioYouth" id="radioYouth">
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="1">Here-to-work</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">Credit
                            Recovery</mat-radio-button>
                    </div>
                </mat-radio-group>
                <mat-checkbox class="example-radio-button" [color]="'primary'"
                    formControlName="chkContracted">Contracted</mat-checkbox>

            </div>
            <div class="col-6">
                <mat-label><b>Access to transportation </b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_AccessToTransportation'"></help-text-btn>
				</mat-label>
                <mat-radio-group aria-label name="radioAccessTT" formControlName="radioAccessTT" id="radioAccessTT">
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="1">Yes</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="2">No</mat-radio-button>
                    </div>
                </mat-radio-group>
                <div class="col">
                    <mat-form-field  style="width: 50%;" appearance="outline" class="example-radio-button">
                        <mat-label>Type</mat-label>
                        <input matInput placeholder="Type" formControlName="accessTT"
                            (focusout)="updateChangeValueLostFocus()" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <mat-divider></mat-divider>
        <div class="row" style="padding-top: 10px">
            <div class="col-6">
                <mat-label><b>Type of Housing - Youth lives in</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_YouthLivesIn'"></help-text-btn>
                </mat-label>
                <mat-radio-group aria-label name="radioTypeOfHousing" formControlName="radioTypeOfHousing"
                    id="radioTypeOfHousing">
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Farmworker
                            housing</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="2">Transitional/Homeless</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="3">Hotel/Motel</mat-radio-button>
                    </div>
                    <div class="col">
                        <mat-radio-button [color]="'primary'" class="example-radio-button"
                            value="4">House/Apartment</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
            <div class="col-6">
                <mat-label><b>Youth lives with (mark all that apply) </b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_YouthLivesWith'"></help-text-btn>
                </mat-label>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkWithaCrew">With a
                        crew</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkWithFriends">With friends
                        outside of work</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkWithParents">With
                        parents/relatives</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkSpouseChildren">With
                        spouse/children</mat-checkbox>
                </div>        
                <div class="col">                        
                    <mat-checkbox [color]="'primary'" formControlName="chkYouthLivesOther">Other</mat-checkbox>
                </div>
                <div class="col">
                    <mat-form-field style="width: 50%;" appearance="outline" class="example-radio-button">
                        <mat-label>Other</mat-label>
                        <input matInput placeholder="Type" formControlName="youthlivesWithOther"
                            (focusout)="updateChangeValueLostFocus()" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <mat-divider></mat-divider>
        <div class="row" style="padding-top: 10px">
            <div class="col-3">
                <mat-label>
                    <b [ngStyle]="{color: this.frmOsy.errors?.['required'] ? 'red': ''}"
                        class="disable_ripple_font">Will participate in *
                    </b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_InterestedIn'"></help-text-btn>
                </mat-label>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkElaEslELD">English (ELA,
                        ESL,ELD)</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkGedHep">GED/HEP</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkHomeLanguage">Home language
                        literacy</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkJobTraining">Job training/CTE</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkInterestedOther">Other</mat-checkbox>
                </div>
                <div class="col">
                    <mat-form-field class="nowrapper" appearance="outline">
                        <mat-label>Other</mat-label>
                        <input matInput placeholder="Type" formControlName="interestedOther"
                            (focusout)="updateChangeValueLostFocus()" />
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkInterestedNone">None</mat-checkbox>
                </div>

            </div>
            <div class="col-3">
                <mat-label><b>Availability</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_Availability'"></help-text-btn>
                </mat-label>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkDays">Days</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkEvenings">Evenings</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkSaturday">Saturday</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkSunday">Sunday</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkAvailabilityOther">Other</mat-checkbox>
                </div>
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Other</mat-label>
                        <input matInput placeholder="Other" formControlName="availabilityOther"
                            (focusout)="updateChangeValueLostFocus()" />
                    </mat-form-field>
                </div>
            </div>
            <div class="col-3">
                <mat-label><b>At Interview, youth received</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_AtInterviewYouthReceived'"></help-text-btn>
                </mat-label>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkEducational">Educational
                        materials</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkHealth">Health kit</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkReferralCommunity">Referral/Community
                        Resources</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [color]="'primary'" formControlName="chkInterviewOther"
                        value="false">Other</mat-checkbox>
                </div>
                
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Other</mat-label>
                        <input matInput placeholder="Other" formControlName="interviewOther"
                            (focusout)="updateChangeValueLostFocus()" />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div style="padding-top: 20px">
            <mat-divider></mat-divider>
        </div>
        <div class="row" style="padding-top: 10px">
            <div class="col-3">
                <mat-label><b>Emergency Contact</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_EmergencyContact'"></help-text-btn>
                </mat-label>
                <div class="col" >
                    <mat-form-field appearance="outline">
                        <mat-label>Emergency Contact</mat-label>
                        <input matInput placeholder="Type" formControlName="emergencyContact" />
                    </mat-form-field>
                </div>
            </div>

            <div class="col-3">
                <mat-label><b>Relationship</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_Relationship'"></help-text-btn>
                </mat-label>
                <div class="col" >
                    <mat-form-field>
                        <mat-label>Relationship</mat-label>
                        <mat-select formControlName="relationship">
                            <mat-option *ngFor="let relation of relationShipData" [value]="relation.name">
                                {{ relation.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-3">
                <mat-label><b>Phone</b>
					<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_OSY_Phone'"></help-text-btn>
                </mat-label>
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Phone</mat-label>
                        <input matInput placeholder="phone" formControlName="phone" telephoneValidator
                            (focusout)="updateChangeValueLostFocus()" />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </form>
    <mat-action-row *ngIf="action!=3">

    </mat-action-row>
    <div class="row" *ngIf="(action==2 || action==3) ">
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Past Edit - {{this.trackHistories.inaHistory.length}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="this.trackHistories.inaHistory.length>=1">
                    <app-past-edit [section]="this.section"></app-past-edit>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

</mat-expansion-panel>